module.exports = __webpack_public_path__ + "static/Koji-cf02d82a1db0bca964f0141fba04157d.png";